import { httpClient } from '@/lib/api/httpClient'
import type { AccountMeResponse } from '@/shared/types'

export const accountApi = {
  getMe: async (): Promise<AccountMeResponse> => {
    const response = await httpClient.get('/vendor/account/me')
    return response.data?.data?.details
  },

  updateProfile: async (data: { name: string; email?: string }): Promise<AccountMeResponse> => {
    const response = await httpClient.patch('/vendor/account/me', data)
    return response.data?.data?.details
  },

  requestPhoneChangeOtp: async (newPhone: string): Promise<void> => {
    await httpClient.post('/vendor/account/phone-change/request', { newPhone })
  },

  verifyPhoneChange: async (data: { newPhone: string; oldOtp: string; newOtp: string }): Promise<AccountMeResponse> => {
    const response = await httpClient.post('/vendor/account/phone-change/verify', data)
    return response.data?.data?.details
  },

  getLocation: async (vendorId: string) => {
    const response = await httpClient.get(`/vendors/${vendorId}/location`)
    return response.data?.data?.location ?? null
  },

  updateLocation: async (vendorId: string, data: {
    latitude: number; longitude: number; address: string; label: string;
    addressLine1?: string; addressLine2?: string; landmark?: string;
    city?: string; state?: string; postalCode?: string; phoneNumber?: string;
  }) => {
    const response = await httpClient.put(`/vendors/${vendorId}/location`, data)
    return response.data
  },

  getBankAccount: async (vendorId: string) => {
    const response = await httpClient.get(`/vendors/${vendorId}/bank-account`)
    return response.data?.data ?? null
  },

  saveBankAccount: async (vendorId: string, data: {
    accountHolderName: string; accountNumber: string; ifscCode: string;
    bankName: string; upiId?: string;
  }) => {
    const response = await httpClient.put(`/vendors/${vendorId}/bank-account`, data)
    return response.data?.data
  },
}
